import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetCustomFieldDefinitions = function () {
    return useApiCall(function (signal) { return api.customFields.apiCustomFieldDefinitionGet({ signal: signal }); }, [], true, []);
};
